// extracted by css-extract-rspack-plugin
var _1 = "Q0vsI";
export { _1 as "categoryMenu" }
